app.service("SupportService", ['$rootScope', 'bowser', function ($rootScope, bowser) {

    const siteHelper = $rootScope.site_helper;

    this.reportBug = function (bugReport, callback) {

        bugReport.order_details = $rootScope.model.order.current_order;
        bugReport.customer_data = $rootScope.model.account.customer_data;
        bugReport.browser = bowser;

        const endpoint = '/request/bug-report.php';

        $rootScope.service.request.postRequest(endpoint, bugReport, function (success, data, messages) {
            if (success) {
                messages = siteHelper.addSuccessMessage("Bug report sent! Thank you for your help.");
            }
            if (callback) {
                callback(success, data, messages)
            }
        });

    }

}]);